import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { UserWidgetConfigView } from "./UserWidgetConfigView";
import { UserWidgetConfigViewStore } from "../../store/UserWidgetConfigViewStore";
import { useStore } from "../../../../hooks";

export const UserWidgetConfigViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/userWidgetConfig/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserWidgetConfigViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <UserWidgetConfigView userWidgetConfigViewStore={store} />
      </PageLayout>
    </div>
  );
});
